import { ConfigVars, EnvVars } from "@/types";
import ConfigFile from "../../config.json";

const config = ConfigFile as ConfigVars;
export default new EnvVars(config);
